<template>
  <div class="">
    <main>
      <section class="row contained">
        <article class="post col-wide">
          <!-- BLOG TITLE -->
          <h1 v-if="blogExist && ImageLoaded">
            <!-- <a href="https://luglawhaulsano.net/4/8248436" target="_blank"> -->
            {{ blog.title.value }}
            <!-- </a> -->
          </h1>
          <Skeleton v-else width="20rem" class="mb-2"></Skeleton>

          <!-- BLOG DETAIL -->
          <div v-if="blogExist && ImageLoaded" class="author row fc-primary fw-bold mb-10 pr-2 pl-2 blog-info">
            <p class="fc-primary mb-0 w-auto pr-1 pl-1" aria-label="A link to comment section">
              <small class="w-auto p-0"><i class="bi bi-person-circle"></i> {{ blog.created_user }}</small>
            </p>
            <a href="#comments" class="fc-primary mb-0 w-auto pr-2 pl-1" aria-label="A link to comment section">
              <small class="ml-10"><i class="bi bi-chat-right-text"></i> {{ $t("comments") }}:
                {{ blog.blog_comments_length }}</small>
            </a>
            <p class="fc-primary mb-0 w-auto pr-1 pl-1" aria-label="A link to comment section">
              <!-- <a href="https://luglawhaulsano.net/4/8248436" target="_blank"> -->
              <small class="mr-auto w-auto">
                {{ $t("last_update") }}: {{ blog.added_at }}
              </small>
              <!-- </a> -->
            </p>
          </div>
          <div v-else class="flex justify-content-between mb-3">
            <Skeleton width="4rem"></Skeleton>
            <Skeleton width="4rem"></Skeleton>
            <Skeleton width="4rem"></Skeleton>
          </div>

          <!-- BLOG THUMBNAIL -->
          <img v-if="blogExist" :src="`/assets/posts/blogs/${blog.slug.value}/${blog.slug.value}-1200x630.jpeg`" :alt="blog.title"
            class="img-unheight" @load="ImageLoaded = true" />
          <Skeleton v-else height="30rem" class="img-skeleton"></Skeleton>
          <!-- BLOG SUB-TITLE & CONTENT -->
          <h3 v-if="blogExist && ImageLoaded">{{ blog.sub_title }}</h3>
          <Skeleton v-else width="30rem" class="mt-2 mb-2"></Skeleton>
          <div v-if="blogExist && ImageLoaded" class="content" v-html="blog.content.value"></div>
          <hr />
          <div v-if="blogExist && ImageLoaded && blog.social_network_links.value.length > 0">
            <div v-if="blog.youtubeVideoLink != null" class="youtube-container">
              <iframe :src="blog.youtubeVideoLink.value" :title="blog.title.value" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <!-- SOCIAL NETWORK LINKS -->
            <!-- <a href="https://luglawhaulsano.net/4/8248436" target="_blank"> -->
            <h3>{{ $t("blog_links_on_social_media") }}</h3>
            <!-- </a> -->
            <a v-for="item in blog.social_network_links.value" :key="item" :href="item.link" target="”_blank”"
              class="reference">
              <h6>{{ item.site }}</h6>
            </a>
          </div>
          <hr />
          <!-- REFERENCES -->
          <!-- <a href="https://luglawhaulsano.net/4/8248436" target="_blank"> -->
          <h3 v-if="blogExist && ImageLoaded">{{ $t("references") }}:</h3>
          <!-- </a> -->
          <!-- KEYWORDS -->
          <div v-if="blogExist && ImageLoaded" class="references">
            <a v-for="item in blog.blog_references.value" :key="item" :href="item.reference" target="”_blank”"
              class="reference">
              <h6>{{ item.reference }}</h6>
            </a>
          </div>
          <div v-else class="w-full">
            <br />
            <br />
            <br />
            <Skeleton class="mt-60 mb-2"></Skeleton>
            <Skeleton width="50rem" class="mt-2 mb-2"></Skeleton>
            <Skeleton class="mt-2 mb-2"></Skeleton>
            <Skeleton width="50rem" class="mt-2 mb-2"></Skeleton>
            <Skeleton class="mt-2 mb-2"></Skeleton>
            <Skeleton width="50rem" class="mt-2 mb-2"></Skeleton>
            <Skeleton class="mt-2 mb-2"></Skeleton>
            <Skeleton width="50rem" class="mt-2 mb-2"></Skeleton>
            <Skeleton class="mt-2 mb-2"></Skeleton>
            <Skeleton width="50rem" class="mt-2 mb-2"></Skeleton>
          </div>
          <!-- BLOG SOCIAL SHARE -->
          <div v-if="blogExist && ImageLoaded" class="row flex-alig-center mb-20 share-icons">
            <!-- <a href="https://luglawhaulsano.net/4/8248436" class="share-icons-label" target="_blank"> -->
            <p class="no-margin mr-10">{{ $t("share") }}:</p>
            <!-- </a> -->
            <a href="#" class="icon-link" aria-label="Follow us on facebook">
              <i class="bi bi-facebook"></i>
            </a>
            <a href="#" class="icon-link" aria-label="Follow us on instagram">
              <i class="bi bi-instagram"></i>
            </a>
            <a href="#" class="icon-link" aria-label="Follow us on twitter">
              <i class="bi bi-twitter"></i>
            </a>
            <a href="#" class="icon-link" aria-label="Follow us on youtube">
              <i class="bi bi-youtube"></i>
            </a>
          </div>
          <hr v-if="blogExist && ImageLoaded" />
          <!-- BLOG COMMENTS SECTION -->
          <ul v-if="blogExist && ImageLoaded" class="comments-list" id="comments">
            <li class="fs-h4">
              <!-- <a href="https://luglawhaulsano.net/4/8248436" target="_blank"> -->
              {{ $t("comments") }}:
              <!-- </a> -->
            </li>

            <li v-for="item in blog.blog_comments.value" :key="item.id" class="card-comment">
              <img :src="`/assets/profiles/${item.created_user.profile_image}`" alt="" />
              <div class="info">
                <div class="row comment-info">
                  <p class="fw-bold no-margin w-auto">{{ item.created_user.name }}</p>
                  <p class="no-margin mr-a text-left w-auto">{{ item.added_at }}</p>
                </div>
                <p>{{ item.comment }}</p>
              </div>
            </li>
          </ul>

          <!-- BLOG LEAVE A COMMENT FORM -->
          <a href="https://luglawhaulsano.net/4/8248436" target="_blank"><span v-if="blogExist && ImageLoaded"
              class="fs-h4 mb-15">{{
                $t("leave_a_comment")
              }}</span></a>
          <form v-if="blogExist && ImageLoaded && isLogged" action="#" class="message-form mt-50 mb-25">
            <textarea id="comment-message" rows="5" placeholder="..." aria-label="Input for writing message"
              v-model="comment"></textarea>
            <button type="submit" class="btn-bg1 border-round mt-20 w-auto" @click.prevent="sendComment">
              {{ $t("send_the_comment") }}
            </button>
          </form>
          <div v-if="blogExist && ImageLoaded" class="not-logged">
            <router-link to="/auth/login" name="login">{{ $t("to_comment_register_here") }}.</router-link>
          </div>
          <br />
          <br />
          <!-- KEYWORDS -->
          <div v-if="blogExist && ImageLoaded" class="keywords">
            <router-link v-for="item in blog.tags_ar.value" :key="item" :to="`/posts/search/${item}?q=${item}`"
              class="keywords-ar" :aria-label="`${item}`">
              <h6>{{ item }}</h6>
            </router-link>
            <!-- <router-link v-for="item in blog.tags_en.value" :key="item"
              :to="`/posts/search/${item.name}?q=${item.name}`" class="keywords-en" :aria-label="`${item.name}`">
              <h6>{{ item.name }}</h6>
            </router-link> -->
          </div>
        </article>
        <div v-if="blogExist && ImageLoaded" class="col-slim">
          <div class="card-side">
            <a href="https://luglawhaulsano.net/4/8248436" target="_blank"><span class="fs-h3 side-title">{{
              $t("similar_articles") }}</span></a>
            <hr />
            <!-- <div v-for="item in relatedBlogs" :key="item.id">
              <router-link
                @click.prevent="getData(item.slug)"
                :to="`/posts/${item.slug}`"
                class="card-post"
              >
                <img
                  :src="`/assets/posts/blogs/${item.slug}/${item.slug}-310x150.jpeg`"
                  alt=""
                />
                <div class="info">
                  <p class="no-margin fw-bold">{{ item.title }}</p>
                </div>
              </router-link>
            </div> -->
            <div class="container m-auto d-flex flex-wrap justify-content-center align-items-center bg-white mt-2 pt-2"
              style="border-radius: 12px">
              <!-- <div v-for="item in newBlogs" :key="item.id" class="post-card-container col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-5 col-xs-5"> -->
              <div v-for="item in relatedBlogs" :key="item.id" class="post-card-container d-flex flex-wrap">
                <div class="post-card-img-container">
                  <!-- <router-link :to="`/posts/${item.slug}`"> -->
                  <img :src="`/assets/posts/blogs/${item.slug}/${item.slug}-310x150.jpeg`" :alt="item.title" />
                  <!-- </router-link> -->
                  <router-link @click.prevent="getData(item.slug)"
                    :to="`${(lang == '') ? item.slug : item.slug}`" class="post-img-container-overlay"
                    :aria-label="`${item.title}`"></router-link>
                  <!-- <router-link :to="`categories/${item.slug}`" class="post-card-category">{{ `${item.sub_category.name}`
                  }}</router-link> -->
                </div>
                <router-link @click.prevent="getData(item.slug)" :to="`${(lang == '') ? item.slug : `${lang}/` + item.slug}`"
                  :aria-label="`${item.title}`">
                  <h3>{{ item.title }}</h3>
                </router-link>
              </div>
            </div>
          </div>
          <hr />
          <div class="card-side">
            <a href="https://luglawhaulsano.net/4/8248436" target="_blank"><span class="fs-h3 side-title">{{
              $t("other_articles") }}</span></a>
            <hr />
            <!-- <div v-for="item in trendBlogs" :key="item.id" class="d-flex flex-warp related-posts-container">
              <router-link
                @click.prevent="getData(item.slug)"
                :to="`/posts/${item.slug}`"
                class="card-post"
              >
              <div class="related-post-img-container">
                <img
                  :src="`/assets/posts/blogs/${item.slug}/${item.slug}-310x150.jpeg`"
                  alt=""
                />
              </div>
                <div class="info">
                  <p class="no-margin fw-bold">{{ item.title }}</p>
                </div>
              </router-link>
            </div> -->
            <div class="container m-auto d-flex flex-wrap justify-content-center align-items-center bg-white mt-2 pt-2"
              style="border-radius: 12px">
              <!-- <div v-for="item in newBlogs" :key="item.id" class="post-card-container col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-5 col-xs-5"> -->
              <div v-for="item in trendBlogs" :key="item.id" class="post-card-container d-flex flex-wrap">
                <div class="post-card-img-container">
                  <!-- <router-link :to="`/posts/${item.slug}`"> -->
                  <img :src="`/assets/posts/blogs/${item.slug}/${item.slug}-310x150.jpeg`" :alt="item.title" />
                  <!-- </router-link> -->
                  <router-link @click.prevent="getData(item.slug)"
                    :to="`${(lang == '') ? item.slug : `${lang}/` + item.slug}`" class="post-img-container-overlay"
                    :aria-label="`${item.title}`"></router-link>
                  <!-- <router-link :to="`categories/${item.slug}`" class="post-card-category">{{ `${item.sub_category.name}`
                  }}</router-link> -->
                </div>
                <router-link @click.prevent="getData(item.slug)" :to="`${(lang == '') ? item.slug : `${lang}/` + item.slug}`"
                  :aria-label="`${item.title}`">
                  <h3>{{ item.title }}</h3>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
  <div class="card flex justify-content-center custom-loading" v-if="loading">
    <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="8" fill="var(--surface-ground)"
      animationDuration=".5s" aria-label="Custom ProgressSpinner" />
  </div>
</template>

<script setup>
import { ref, toRef, onBeforeMount, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import { useToast } from "primevue/usetoast";
// import { translate } from "api-translator";
// import { translate } from "google-translate-api-browser";

// Start Data Section
const store = useStore();
const route = useRoute();
const router = useRoute();
const toast = useToast();
const loading = ref();
const layout = ref("grid");
const slug = ref();
const lang = ref();
const blogExist = ref(false);
const ImageLoaded = ref(false);
const blog = {
  added_at: ref(),
  activation: ref(),
  blog_comments: ref(),
  blog_comments_length: ref(),
  blog_evaluations: ref(),
  blog_references: ref(),
  social_network_links: ref([]),
  youtubeVideoLink: ref(null),
  blog_tags: ref(),
  created_at: ref(),
  created_user: ref(),
  created_user_id: ref(),
  downloads: ref(),
  id: ref(),
  keywords: ref(),
  publish_date: ref(),
  short_content: ref(),
  slug: ref(),
  sub_category: ref(),
  sub_category_id: ref(),
  sub_title: ref(),
  title: ref(),
  updated_at: ref(),
  updated_user_id: ref(),
  version: ref(),
  views: ref(),
  tags_ar: ref(),
  tags_en: ref(),
  content: ref(),
};
const relatedBlogs = ref("");
const trendBlogs = ref("");
const comment = ref("");
// End Data Section
const options = {
  rpcids: "MkEWBc",
  from: "ua",
  to: "en",
  hl: "en",
  tld: "com",
  raw: true,
};
// Start onBeforeMount Section
onBeforeMount(() => {
  slug.value = route.params.slug;
  lang.value = route.params.lang;
  store.commit('setHeaderMarginFlag', { page: 'Blog' });
  store.commit('setLang', { lang: lang.value});
  getData(route.params.slug, lang.value);
});
// End onBeforeMount Section

// Start Computed Section
const isLogged = computed(() => {
  return store.getters.isAuthenticated;
});
// End Computed Section

// Start Methods Section
const getData = (slugParm, langParm) => {
  loading.value = true;
  blogExist.value = false;
  let url =
    langParm == ""
      ? `/api/get-blog/${slugParm}`
      : `/api/${langParm}/get-blog/${slugParm}`;

  axios
    .get(url)
    .then((res) => {
      if (res.data.data) {
        blogExist.value = true;
        initVariables(
          res.data.data,
          res.data.related_blogs,
          res.data.trend_blogs,
          res.data.content
        );
      } else {
        toast.add({
          severity: "warning",
          summary: "تحذير",
          detail: "محتوى غير موجود، او قد تم إزالته",
          life: 60000,
        });
        // router.push({ path: '/not-found' });
      }
      loading.value = false;
    })
    .catch((err) => {
      loading.value = false;
      console.error(err);
    });
};

const initVariables = (data, relBlogs, treBlogs, content) => {
  setMetaData(data);
  store.commit("setBreadcrumb", {
    items: [
      { label: "الفئات", route: "/categories" },
      { label: data.sub_category.category.name, route: "/categories" },
      { label: data.sub_category.name, route: `/categories/${data.sub_category.slug}` },
      { label: data.title },
    ],
  });

  blog.added_at.value = data.added_at;
  blog.activation.value = data.activation;
  blog.blog_comments.value = data.blog_comments;
  blog.blog_comments_length.value = data.blog_comments.length;
  blog.blog_evaluations.value = data.blog_evaluations;
  blog.blog_references.value = data.blog_references;
  // blog.social_network_links.value = data.social_network_links;
  blog.blog_tags.value = data.blog_tags;
  blog.created_at.value = data.created_at;
  blog.created_user = data.added_by;
  blog.created_user_id.value = data.created_user_id;
  blog.downloads.value = data.downloads;
  blog.id.value = data.id;
  blog.keywords.value = data.keywords;
  blog.publish_date.value = data.publish_date;
  blog.short_content.value = data.short_content;
  blog.slug.value = data.slug;
  blog.sub_category.value = data.sub_category;
  blog.sub_category_id.value = data.sub_category_id;
  blog.sub_title.value = data.sub_title;
  blog.title.value = data.title;
  blog.updated_at.value = data.updated_at;
  blog.updated_user_id.value = data.updated_user_id;
  blog.version.value = data.version;
  blog.views.value = data.views;
  blog.tags_ar.value = data.tags_ar;
  // blog.tags_en.value = data.tags_en;
  blog.content.value = content;

  for (let i = 0; i < data.social_network_links.length; i++) {
    if (data.social_network_links[i].site == "Youtube Embed") {
      blog.youtubeVideoLink.value = data.social_network_links[i].link;
    } else {
      blog.social_network_links.value.push(data.social_network_links[i]);
    }
  }

  relatedBlogs.value = relBlogs;
  trendBlogs.value = treBlogs;
};

const setMetaData = (data) => {
  
  let description = data.short_content;

  if (data.short_content != "" && data.short_content != null) {
    if (data.short_content == "\n") {
      description = data.title;
    }
  }

  description = data.title;

  store.commit("setPageTitle", {
    // meta_name_description: data.short_content,
    meta_name_description: description,
    title: data.title,
    meta_name_keywords: `${description}`,
    meta_name_thumbnail: `https://toutaworld.com/assets/posts/blogs/${data.slug}/${data.slug}-1200x630.jpeg`,
    meta_name_author: "x7 Technology company",
    meta_name_msapplication_TileColor: "#f8fafc",
    meta_name_msapplication_square70x70logo: `https://toutaworld.com/assets/posts/blogs/${data.slug}/${data.slug}-70x70.png`,
    meta_name_msapplicationsquare150x150logo: `https://toutaworld.com/assets/posts/blogs/${data.slug}/${data.slug}-150x150.png`,
    meta_name_msapplicationwide310x150logo: `https://toutaworld.com/assets/posts/blogs/${data.slug}/${data.slug}-310x150.jpeg`,
    meta_name_msapplicationsquare310x310logo: `https://toutaworld.com/assets/posts/blogs/${data.slug}/${data.slug}-310x310.png`,
    meta_property_og_title: data.title,
    meta_property_og_url: `https://toutaworld.com${route.path}`,
    meta_property_og_image_secure_url: `https://toutaworld.com/assets/posts/blogs/${data.slug}/${data.slug}-1200x630.jpeg`,
    meta_property_og_image: `https://toutaworld.com/assets/posts/blogs/${data.slug}/${data.slug}-1200x630.jpeg`,
    meta_property_og_image_width: "1200px",
    meta_property_og_image_height: "630px",
    meta_property_og_site_name: "عالم توتا",
    meta_property_og_description: data.short_content,
    meta_property_og_type: "article",
    meta_property_og_image_alt: data.title,
    meta_property_twitter_card: "summary_large_image",
    meta_property_twitter_site: "@ToutaWorld",
    meta_property_twitter_creator: "@ToutaWorld",
    meta_property_twitter_title: data.title,
    meta_property_twitter_description: data.short_content,
    meta_property_twitter_image: `https://toutaworld.com/assets/posts/blogs/${data.slug}/${data.slug}-1200x630.jpeg`,
    meta_property_twitter_image_alt: data.title,
  });
};

const sendComment = () => {
  loading.value = true;
  let formData = new FormData();
  formData.append("blog_id", blog.id.value);
  formData.append("comment", comment.value);

  axios
    .post("/api/comments", formData)
    .then((res) => {
      toast.add({
        severity: "success",
        summary: "نجاح",
        detail: "تم ارسال التعليق بنجاح",
        life: 60000,
      });
      getData();
    })
    .catch((err) => {
      console.error(err);
      toast.add({
        severity: "success",
        summary: "خطأ",
        detail: "هناك شيئ خاطئ",
        life: 60000,
      });
      loading.value = false;
    });
};
// End Methods Section
</script>
<style lang="css">
.post h1 {
  font-size: 2rem;
}

.post h1,
.post h3 {
  font-weight: bold;
  width: fit-content;
  margin-bottom: 20px;
  border-bottom: 7px solid #007fab;
}

.post h3 {
  border-bottom-width: 4px;
}

.content>* {
  font-size: 1.5rem;

}

.content ul {
  list-style-type: disc;
}

.content ul li::marker {
  color: #324381;
}

.share-icons>* {
  max-width: 50px !important;
}

.icon-link>.bi {
  width: 3rem;
  height: 3rem;
  font-size: 30px;
}

.share-icons .share-icons-label {
  max-width: 90px !important;
  font-size: 20px;
}

.references .reference h6 {
  font-size: 1.1rem;
  color: #0000ff;
  text-shadow: 0 0 0px black;
}

.reference {
  display: block;
  width: fit-content;
}

.keywords-ar,
.keywords-en {
  margin: 0 7px;
}

.keywords-ar h6,
.keywords-en h6 {
  display: inline-block;
}

.img-skeleton {
  border-radius: 20px;
  overflow: hidden;
}

.side-title {
  border-bottom: 1px solid #74a5ff;
  text-align: center;
}

.related-posts-container {
  width: 50%;
}

/* Content */
.section-heading {
  font-weight: bold;
}

.post-card-container {
  width: 50%;
  margin-bottom: 20px;
  background-color: #ffffff;
}

@media (max-width: 576px) {
  .post-card-container {
    width: 50%;
  }
}

.post-card-container .post-card-img-container {
  position: relative;
  max-width: 90%;
  max-height: 65px;
  text-decoration: none !important;
  border: 2px solid #007fab;
  border-radius: 12px;
  overflow: hidden;
}

.post-card-container .post-card-img-container a {
  text-decoration: none !important;
}

.post-card-container .post-card-img-container .post-img-container-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00171f;
  opacity: 0;
  border-radius: 10px;
  transition: all 0.4s;
}

.post-card-container .post-card-img-container:hover .post-img-container-overlay {
  opacity: 0.3;
}

.post-card-container .post-card-img-container a::after {
  display: none !important;
}

.post-card-container .post-card-img-container a img::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00171f;
  opacity: 1;
  -webkit-transform: scale(0);
  -moz-transform: scale(0);
  -ms-transform: scale(0);
  -o-transform: scale(0);
  transform: scale(0);
  -webkit-transition: -webkit-transform 0.4s;
  transition: -webkit-transform 0.4s;
  -o-transition: -o-transform 0.4s;
  -moz-transition: transform 0.4s, -moz-transform 0.4s;
  transition: transform 0.4s;
  transition: transform 0.4s, -webkit-transform 0.4s, -moz-transform 0.4s,
    -o-transform 0.4s;
}

.post-card-container .post-card-img-container img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}

.post-card-container .post-card-img-container .post-card-category {
  position: absolute;
  top: 7px;
  right: 7px;
  text-decoration: none !important;
  background-color: #007fab;
  /* background-color: #0061ff; */
  color: #ffffff !important;
  padding: 7px;
  border-radius: 7px;
}

.post-card-container .post-card-img-container .post-card-category:hover {
  background-color: #006688;
}

.post-card-container a {
  width: 90%;
  text-align: center;
}

.post-card-container a h3 {
  width: 90%;
  height: 38.4px;
  overflow: hidden;
  margin-top: 10px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

.post-card-container a h3 span {
  border-bottom: 7px solid #007fab;
  color: #007fab;
}

.youtube-container {
  display: flex;
  justify-content: center;
}

.youtube-container iframe {
  aspect-ratio: 16 / 9;
  width: 100% !important;
}

/* Content */
</style>
